module.exports = __webpack_public_path__ + "static/media/tartine-olo.c3ff46b5.png";